// al-countdown.component.ts

import { Component, Input } from '@angular/core';

@Component({
    selector: 'al-countdown',
    template: `
        <div id="countDown" class="al-countdown al-countDown-{{ahCountDownColor}}">
            <span id="daysNumber" class="al-countdown-number">{{ahCountDownNoValue}}</span>
            <span class="al-countdown-days">
                <span id="days" *ngIf="ahCountDownUnit; else ahCountDownUnitTmpl" [innerHtml]="ahCountDownUnit">{{ahCountDownUnit}}</span>
                <span id="left" *ngIf="ahCountDownUnitText; else ahCountDownUnitTextTmpl" [innerHtml]="ahCountDownUnitText">{{ahCountDownUnitText}}</span>
            </span>
        </div>

        <!-- If ahCountDownUnit is null or blank, then check for Custom content and render it -->
        <ng-template #ahCountDownUnitTmpl><ng-content select=[ahCountDownUnit]></ng-content></ng-template>

        <!-- If ahCountDownUnitText is null or blank, then check for Custom content and render it -->
        <ng-template #ahCountDownUnitTextTmpl><ng-content select=[ahCountDownUnitText]></ng-content></ng-template>
    `
})
export class AlCountDownComponent {

    // Type of color for  complete countDown text.
    @Input() ahCountDownColor: string;

    // Count Down Number value.
    @Input() ahCountDownNoValue: string;

    // Count Down Unit like Days, Months , Years.
    @Input() ahCountDownUnit: string = '';

    // Count Down Unit text like Left, Pending, To Go.
    @Input() ahCountDownUnitText: string = '';

}
